// extracted by mini-css-extract-plugin
export var fill = "sprite-module--fill--6666b";
export var sprite = "sprite-module--sprite--417ba";